import { Component, input } from '@angular/core';
import type { FormArray } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, BoxComponent, HeadingComponent } from '@core/user-interface-legacy';
import type { SkillRatingForm } from '@recruitee/evaluations-types';

import { EvaluationQuestionCardComponent } from '../evaluation-question-card/evaluation-question-card.component';
import { EvaluationSingleChoiceFieldComponent } from '../evaluation-single-choice-field/evaluation-single-choice-field.component';

@Component({
  selector: 'rt-evaluation-skills-field',
  templateUrl: './evaluation-skills-field.component.html',
  styleUrls: ['./evaluation-skills-field.component.less'],
  imports: [
    BadgeComponent,
    EvaluationQuestionCardComponent,
    EvaluationSingleChoiceFieldComponent,
    TranslatePipe,
    BoxComponent,
    HeadingComponent,
  ],
})
export class EvaluationSkillsFieldComponent {
  public readonly skillRatings = input.required<FormArray<SkillRatingForm>>();
  public readonly required = input<boolean>(false);
  public readonly showValidationErrors = input<boolean>(false);
}
